<page-toolbar [pageActions]="pageActions" title="Detail Role"></page-toolbar>

<page-content *ngIf="!!boundRole">
  <mat-card appearance="outlined">
    <mat-card-title>{{boundRole.name}}</mat-card-title>
    <p [innerHTML]="boundRole.description"></p>
  </mat-card>
  <div class="spacer"></div>
  <app-profile-role-manager [id]="id"></app-profile-role-manager>

</page-content>

